<template>
  <div>
      <el-form :model="from" :rules="rules" ref="ruleForm" style="padding: 0 10%;" label-width="30%">
		  <el-form-item label="组织架构" prop="organize_ids" style="margin-left:-80px" v-show="ruleForm.id != null && ruleForm.id != ''">
			<div style="border:1px solid #DCDFE6; width:95%;border-radius:5px;padding-left:5%;">
				{{$globals.group_name + "/" + ruleForm.organize_name}}
			</div>
		</el-form-item>
		<el-form-item label="组织架构" prop="organize_ids" style="margin-left:-80px" v-show="ruleForm.id === null || ruleForm.id === ''">
			<!-- <el-cascader v-model="ruleForm.organize_ids" clearable
			style="margin-left:1px;width:100%" :props="props" collapse-tags></el-cascader> -->
			<el-cascader v-model="ruleForm.organize_ids" clearable
			    style="margin-left:1px;width:100%" collapse-tags :props="props"></el-cascader>
		</el-form-item>
		<el-form-item label="岗位" prop="post_id" style="margin-left:-80px">
			<el-select v-model="ruleForm.postId" style="margin-left:1px;width:100%" placeholder="请选择岗位"
				multiple collapse-tags filterable>
				<el-option v-for="item in postList" :key="item.id" :label="item.post_name" :value="item.id">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="性别" prop="spare5" style="margin-left:-80px">
			<el-select v-model="ruleForm.spare5" placeholder="请选择性别" style="margin-left:1px;width:100%">
				<el-option v-for="item in spare" :key="item.value" :label="item.data"
					:value="item.value">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="保费金额" prop="insurance_price" style="margin-left:-80px">
			<el-input type="number" v-model="ruleForm.insurance_price" style="width: 100%;" placeholder="请输入保费金额"></el-input>
		</el-form-item>
		<el-form-item label="年龄" prop="age" style="margin-left:-80px">
			<el-select v-model="ruleForm.age" placeholder="请选择年龄" clearable style="margin-left:1px;width:100%">
				<el-option v-for="age in ageList" :key="age.id" :label="age.data"
					:value="age.id">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item style="text-align: center;" label-width="0px">
			<el-button type="primary" @click="Add" 
				style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
		</el-form-item>
	</el-form>
  </div>
</template>

<script>
export default {
    data(){
		var organizeFind = async (e, spare8) => {
			var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
				identification: "1",
				organize_id: e,
				spare8: spare8,
			});
		        return organizeList.data;
		    };
        return{
			//组织架构数据
			organizeList: [],
			//职位数据
			postList: [],
			//年龄范围数据
			ageList: [],
            ruleForm:{
				id:'',
				organize_ids: [],
				postId:[],
				post_id:'',	
				insurance_price:'',	
				age:'',
				spare5:'',
			},
			spare:[
				{
					data:'不限',
					value:2
				},
				{
					data:'男',
					value:1
				},
				{
					data:'女',
					value:0
				},
			],
			
			//级联下拉配置
			props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
				value: "id",
				label: "organize_name",
				children: "organizeList",
				checkStrictly: true,
				multiple: true,
			},
        }
    },
    methods:{
        async Add() {
			if(this.ruleForm.organize_ids == ''){
				this.$message.error('请选择组织架构！');
			}else if(this.ruleForm.postId == null || this.ruleForm.postId.length == 0 ){
				this.$message.error('请选择岗位！');
			}else if(this.ruleForm.insurance_price == ''){
				this.$message.error('请输入保费金额！');
			}else{
				var temporary = [];
				this.ruleForm.organize_ids.forEach(item => {
				    temporary.push(item[item.length - 1]);
				})
				this.ruleForm.organize_ids = temporary
				// var organize_ids = [];
				// temporary.forEach(item => {
				//     organize_ids += item + ',' ;
				//     });
				// temporary.split(',').forEach(item => {
				// 		organize_ids += item + ',';
				// })
				// this.staff_name = staff_name;
				var url = 'PremiumTable/insertPremiumTable';
				var record = {
					organize_id: this.ruleForm.organize_ids,
					post_id:this.ruleForm.post_id,
					insurance_price:this.ruleForm.insurance_price,
					age_id:this.ruleForm.age,
					postId:this.ruleForm.postId,
					spare5:this.ruleForm.spare5,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.$parent.$parent.Return();
						this.trash();
					} else {
						this.$message.warning(data);
						this.trash();
					}
				}
			}	
		},
			async Update() {
				var url = 'PremiumTable/updatePremiumTable';
				var record = {
					id:this.ruleForm.id,
					post_id:this.ruleForm.post_id,
					insurance_price:this.ruleForm.insurance_price,
					age_id:this.ruleForm.age,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.$parent.$parent.Return();
						this.trash();
					} else {
						this.$message.warning(data);
					}
				}
			},
			
			//清除数据
			trash() {
				this.ruleForm.id = '';
				this.ruleForm.organize_ids = [];
				this.ruleForm.organize_ids = '';
				this.ruleForm.post_id = '';
				this.ruleForm.insurance_price = '';
				this.ruleForm.age ='';
				this.ruleForm.spare5 = '';
        		this.ruleForm.postId = [];
			},
    },
    async created() {
		this.ruleForm = this.$parent.$parent.ruleForm;
		// 职位数据
		var postList = await this.$globals.AxiosPost('post/selectFind', {});
		this.postList = postList.data;
		// 年龄段类型
		var ageList = await this.$globals.AxiosPost("/dictionaries/selectFind", {
		data_grouping: "age_group"
		});
		this.ageList = ageList.data;
		},

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// gzxbfgl_add.vue?36210eb0